import { Injectable } from '@angular/core';
import { StorageService } from 'ngx-mat-esign360';
import {
  ClientSignFieldsByDocument,
  IClientSignField,
} from '@app/transaction-builder/model/sign-field.model';

@Injectable({
  providedIn: 'root',
})
export class SignFieldsStorageService {
  readonly SIGN_FIELDS_KEY = 'signFieldsByDocument';

  constructor(private storage: StorageService) {}

  getSignFieldsByDocument(): ClientSignFieldsByDocument {
    return this.storage.getData(this.SIGN_FIELDS_KEY) || {};
  }

  clearSignFieldsByDocument() {
    this.setSignFieldsByDocument({});
  }

  setSignFieldsByDocument(signFieldsByDocuments: ClientSignFieldsByDocument) {
    return this.storage.saveData(this.SIGN_FIELDS_KEY, signFieldsByDocuments);
  }

  getDocumentSignFields(documentCid: string): IClientSignField[] {
    return this.getSignFieldsByDocument()[documentCid] || [];
  }

  setDocumentSignFields(documentCid: string, signFields: IClientSignField[]) {
    this.setSignFieldsByDocument({ ...this.getSignFieldsByDocument(), [documentCid]: signFields });
  }

  clearDocumentSignFields(documentCid: string) {
    const signFieldsByDocument = this.getSignFieldsByDocument();
    delete signFieldsByDocument[documentCid];
    this.setSignFieldsByDocument(signFieldsByDocument);
  }
}
